import styled from "styled-components";
import ShareOnWhatsApp from "./ShareOnWhatsApp";
import Timer from "./Timer";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const Text = styled.div`
    font-size: 20px;
    margin: 28px 0 28px 0;
    text-align: center;
`;

type Props = {
    onNext: () => void;
};

export default function Share(props: Props) {
    return (
        <Container>
            <Text>کیا آپ اپنے دوستوں کو دعوت دینا چاہیں گے؟</Text>
            <Timer seconds={10} onFinish={props.onNext} />
            <ShareOnWhatsApp />
        </Container>
    );
}
